import React from 'react'
import About from '../components/About'

const AboutScreen = () => {
    return <About />
}

export default AboutScreen;